// Configuration for API endpoints
const PLACEHOLDER_DOMAIN = 'yourdomain.com';

function isPlaceholderUrl(url) {
  return !url || url.includes(PLACEHOLDER_DOMAIN);
}

function runtimeOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return null;
}

const config = {
  // Environment detection
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_STAGING: process.env.REACT_APP_ENVIRONMENT === 'staging',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',

  // Dynamic API URL based on environment
  API_URL: (() => {
    const fromEnv = process.env.REACT_APP_API_URL;
    if (!isPlaceholderUrl(fromEnv)) {
      return fromEnv;
    }
    const origin = runtimeOrigin();
    if (origin) {
      return origin;
    }
    if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
      return 'https://staging-api.yourdomain.com';
    }
    if (process.env.NODE_ENV === 'production') {
      return 'https://api.yourdomain.com';
    }
    return 'http://localhost:8080';
  })(),

  // Dynamic Frontend URL
  FRONTEND_URL: (() => {
    const fromEnv = process.env.REACT_APP_FRONTEND_URL;
    if (!isPlaceholderUrl(fromEnv)) {
      return fromEnv;
    }
    const origin = runtimeOrigin();
    if (origin) {
      return origin;
    }
    if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
      return 'https://staging.yourdomain.com';
    }
    if (process.env.NODE_ENV === 'production') {
      return 'https://yourdomain.com';
    }
    return 'http://localhost:3000';
  })(),

  // Scoreboard developer test mode (requires currentUser.is_admin).
  ENABLE_SCOREBOARD_TEST_MODE:
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_ENABLE_SCOREBOARD_TEST_MODE !== 'false'
      : process.env.REACT_APP_ENABLE_SCOREBOARD_TEST_MODE === 'true',

  STRIPE_PUBLISHABLE_KEY:
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    (process.env.REACT_APP_ENVIRONMENT === 'staging' || process.env.NODE_ENV === 'development'
      ? 'pk_test_your_test_key_here'
      : 'pk_live_your_live_key_here'),

  getWebSocketUrl: (leagueId, userId) => {
    const baseUrl = config.API_URL.replace('https://', 'wss://').replace('http://', 'ws://');
    const params = new URLSearchParams({ user_id: String(userId) });
    try {
      // Lazy require avoids circular import: authSession imports config.
      // eslint-disable-next-line global-require
      const { getAccessTokenForWebSocket } = require('./services/authSession');
      const token = getAccessTokenForWebSocket();
      if (token) {
        params.set('access_token', token);
      }
    } catch (_) {
      try {
        const token = sessionStorage.getItem('ffb_access_token');
        if (token) {
          params.set('access_token', token);
        }
      } catch {
        /* ignore */
      }
    }
    return `${baseUrl}/ws/draft/${leagueId}?${params.toString()}`;
  },

  getEnvironmentInfo: () => ({
    environment: config.IS_STAGING ? 'staging' : config.IS_PRODUCTION ? 'production' : 'development',
    apiUrl: config.API_URL,
    frontendUrl: config.FRONTEND_URL,
    isProduction: config.IS_PRODUCTION,
    isStaging: config.IS_STAGING,
    isDevelopment: config.IS_DEVELOPMENT,
  }),
};

if (config.IS_PRODUCTION && typeof window !== 'undefined') {
  if (isPlaceholderUrl(process.env.REACT_APP_API_URL) && !runtimeOrigin()) {
    console.warn(
      '[ffb] Set REACT_APP_API_URL in your build environment to your API origin (e.g. Railway URL).'
    );
  }
  if (isPlaceholderUrl(process.env.REACT_APP_FRONTEND_URL) && !runtimeOrigin()) {
    console.warn(
      '[ffb] Set REACT_APP_FRONTEND_URL to the URL users open in the browser.'
    );
  }
  if (
    config.STRIPE_PUBLISHABLE_KEY.includes('your_test_key') ||
    config.STRIPE_PUBLISHABLE_KEY.includes('your_live_key')
  ) {
    console.warn(
      '[ffb] Stripe publishable key is still a placeholder. Set REACT_APP_STRIPE_PUBLISHABLE_KEY for payments to work.'
    );
  }
}

export default config;
